import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import c3 from "c3";
import { ResizeSensor } from "css-element-queries";
import debounce from "lodash.debounce";

import theme from "theme";
import UIPrimaryWidgetBox from "components/UI/PrimaryWidgetBox";

const Container = styled.div.attrs({ className: "claim-types-chart" })`
  .widget {
    height: 100%;
  }

  .title {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`;

const chartConfig = {
  bindto: "#ct-chart",
  data: {
    columns: [["Owner Retained", 1100], ["Insurer Retained", 354]],
    type: "pie",
    colors: {
      "Owner Retained": theme.colors.vividBlue,
      "Insurer Retained": theme.colors.softCyan
    }
  }
};

const AnalyticsDashboardClaimTypesChart = ({ className }) => {
  const containerRef = useRef(null);
  const [chart, setChart] = useState(null);

  useEffect(() => {
    const aChart = c3.generate(chartConfig);
    setChart(aChart);
  }, []);

  useEffect(
    () => {
      if (containerRef.current && chart) {
        const rs = new ResizeSensor(
          containerRef.current,
          debounce(() => {
            chart.resize();
          }, 200)
        );
        return () => rs.detach();
      }
    },
    [containerRef, chart]
  );

  return (
    <Container className={className} innerRef={containerRef}>
      <UIPrimaryWidgetBox className="widget p">
        <div className="title">Claim Type</div>
        <div className="mt chart" id="ct-chart" />
      </UIPrimaryWidgetBox>
    </Container>
  );
};

export default AnalyticsDashboardClaimTypesChart;
